/* @ngInject */
function AnalyticsInsightsCardController ($scope, $state, $translate, SegmentService, Utils) {
  $scope.dataCard = null

  const api = {
    _mountCardData,
    _getStatusFromTotal
  }

  this.getApi = () => api

  activate()

  function activate () {}

  $translate.onReady(() => {
    $scope.dataCard = api._mountCardData($scope.card)
  })

  $scope.handleCardClick = (routeSlug, cardSlug) => {
    if (!routeSlug) {
      return
    }

    const routeState = 'analytics.dashboard'
    const routeOptions = {
      slug: routeSlug
    }

    $state.go(routeState, routeOptions)

    SegmentService.track('analytics-widget-indicator-click', {
      indicator_name: cardSlug
    })
  }

  $scope.mountDescriptionCard = (slug, status) => {
    const descriptions = {
      // arts
      'analytics-arts-templates-published': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesPublished.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesPublished.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesPublished.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-templates-downloads': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesDownloads.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesDownloads.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesDownloads.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-templates-downloads-by-template': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesDownloadsByTemplate.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesDownloadsByTemplate.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsTemplatesDownloadsByTemplate.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-users-active': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersActive.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersActive.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersActive.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-users-downloads-by-users': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersDownloadsByUsers.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersDownloadsByUsers.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersDownloadsByUsers.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-users-adjusts-by-users': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAdjustsByUsers.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAdjustsByUsers.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAdjustsByUsers.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-users-approval-rate': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersApprovalRate.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersApprovalRate.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersApprovalRate.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-users-adjusts-rate': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAdjustsRate.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAdjustsRate.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAdjustsRate.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-users-average-adjust-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAverageAdjustTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAverageAdjustTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsUsersAverageAdjustTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-team-published-templates': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamPublishedTemplates.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamPublishedTemplates.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamPublishedTemplates.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-team-total-approvals': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamTotalApprovals.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamTotalApprovals.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamTotalApprovals.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-arts-team-average-approval-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamAverageApprovalTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamAverageApprovalTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.arts.artsTeamAverageApprovalTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },

      // announcements
      'analytics-announcements-total-posts': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsTotalPosts.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsTotalPosts.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsTotalPosts.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-announcements-average-posts-views': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsAveragePostsViews.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsAveragePostsViews.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsAveragePostsViews.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-announcements-average-posts-satisfaction': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsAveragePostsSatisfaction.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsAveragePostsSatisfaction.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.announcements.announcementsAveragePostsSatisfaction.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },

      // workflow
      'analytics-workflow-total-requests': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalRequests.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalRequests.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalRequests.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-average-approval-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAverageApprovalTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAverageApprovalTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAverageApprovalTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-approvals-percentage': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowApprovalsPercentage.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowApprovalsPercentage.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowApprovalsPercentage.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-total-approved-requests': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalApprovedRequests.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalApprovedRequests.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalApprovedRequests.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-total-rejected-requests': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalRejectedRequests.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalRejectedRequests.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalRejectedRequests.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-user-adjustments-percentage': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowUserAdjustmentsPercentage.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowUserAdjustmentsPercentage.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowUserAdjustmentsPercentage.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-total-finished-requests': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalFinishedRequests.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalFinishedRequests.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalFinishedRequests.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-adjustments-percentage': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAdjustmentsPercentage.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAdjustmentsPercentage.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAdjustmentsPercentage.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-average-team-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAverageTeamTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAverageTeamTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowAverageTeamTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-deliveries-satisfaction': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowDeliveriesSatisfaction.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowDeliveriesSatisfaction.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowDeliveriesSatisfaction.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-total-adjusts': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalAdjusts.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalAdjusts.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalAdjusts.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-total-attachments': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalAttachments.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalAttachments.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.workflowTotalAttachments.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-answered-delivered-on-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.deliveredOnTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.deliveredOnTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.deliveredOnTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-workflow-answered-delivery-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.averageDeliveryTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.workflow.averageDeliveryTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.workflow.averageDeliveryTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },

      // checklist
      'analytics-checklists-total-checklists': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsTotalChecklists.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsTotalChecklists.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsTotalChecklists.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-checklists-finalization-percentage': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsFinalizationPercentage.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsFinalizationPercentage.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsFinalizationPercentage.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-checklists-average-evaluation': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageEvaluation.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageEvaluation.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageEvaluation.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-checklists-total-action-plans': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsTotalActionPlans.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsTotalActionPlans.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsTotalActionPlans.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-checklists-average-response-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageResponseTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageResponseTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageResponseTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      },
      'analytics-checklists-average-evaluation-time': {
        POSITIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageEvaluationTime.positive'),
        NEGATIVE: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageEvaluationTime.negative'),
        NO_VARIATION: $translate.instant('analyticsInsights.card.descriptions.checklist.checklistsAverageEvaluationTime.noVariation'),
        NO_AVAILABLE: $translate.instant('analyticsInsights.card.descriptions.noAvailable')
      }
    }

    return descriptions?.[slug]?.[status] || ''
  }

  function _mountCardData ({ result, unitType, isPositive }) {
    const { total, previousPeriod } = result
    const parsedIntPreviousPeriod = parseInt(previousPeriod, 10)
    const parsedIntTotal = parseInt(total, 10)
    const parsedFloat = parseFloat(total)
    const percentageFormatted = parsedIntTotal / 100

    const getTotal = {
      TIME: Utils.getSimplifyingTime(total).formatted,
      INTEGER: parsedIntTotal.toLocaleString($scope.locale),
      PERCENTAGE: percentageFormatted.toLocaleString($scope.locale, { style: 'percent' }),
      RATE: parsedFloat === 0 ? '-' : Utils.formatNumber(parsedFloat)
    }

    const { icon, status, formatted } = api._getStatusFromTotal({
      total: parsedIntTotal,
      previousPeriod: parsedIntPreviousPeriod,
      unitType,
      isPositive
    })

    const defaultTotal = getTotal[String(unitType)]

    return {
      totalFormatted: status === 'NO_VARIATION' ? defaultTotal : formatted,
      icon,
      status
    }
  }

  function _getStatusFromTotal ({ total, previousPeriod, unitType, isPositive }) {
    const unitTypes = {
      TIME: () => {
        const expression = Math.abs(total - previousPeriod)

        return {
          formatted: Utils.getSimplifyingTime(expression).formatted,
          expression
        }
      },
      INTEGER: () => {
        const expression = Math.abs((total - previousPeriod) / previousPeriod)

        return {
          formatted: expression.toLocaleString($scope.locale, { style: 'percent' }),
          expression
        }
      },
      PERCENTAGE: () => {
        const expression = Math.abs((total - previousPeriod) / 100)

        return {
          formatted: expression.toLocaleString($scope.locale, { style: 'percent' }),
          expression
        }
      },
      RATE: () => {
        const expression = Math.abs((total - previousPeriod) / previousPeriod)

        return {
          formatted: expression.toLocaleString($scope.locale, { style: 'percent' }),
          expression
        }
      }
    }

    const { expression, formatted } = unitTypes[unitType]()

    if (total === previousPeriod || expression < 0.005) {
      return {
        icon: 'arrow-right',
        status: 'NO_VARIATION',
        formatted
      }
    }

    if (!total || !previousPeriod) {
      return {
        icon: 'minus',
        status: 'NO_AVAILABLE',
        formatted
      }
    }

    if (total > previousPeriod) {
      return {
        icon: 'arrow-up',
        status: isPositive ? 'POSITIVE' : 'NEGATIVE',
        formatted
      }
    }

    return {
      icon: 'arrow-down',
      status: isPositive ? 'NEGATIVE' : 'POSITIVE',
      formatted
    }
  }
}

export { AnalyticsInsightsCardController }
